import { useEffect, useState, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './scripts.js';
import { setTokenInfo } from "./state/token/reducer";
import { setCrowdsaleInfo } from "./state/crowdsale/reducer";
import { setBayonTokenInfo } from "./state/bayontoken/reducer";
import { ethers } from "ethers";
import { useWeb3React } from '@web3-react/core';
import { getName } from './utils/connector_name'
import { hooks as metaMaskHooks, metaMask } from './utils/connectors/metaMask'
import { hooks as walletConnectV2Hooks, walletConnectV2 } from './utils/connectors/walletConnectV2'
import { useDispatch } from "react-redux";
import Loading from "./Loading";
import Landing from "./layouts/Landing";
import Dashboard from "./layouts/Dashboard";
import RLink from "./layouts/RLink";
import ClearCache from "./layouts/ClearCache";
import USDTBEP20 from "./abi/USDTBEP20";
import Crowdsale from "./abi/Crowdsale";
import BayonToken from "./abi/BayonToken";
import "./utils/i18n";


export default function App(history) {
  const { connector, account, chainId, provider, active } = useWeb3React();

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedprovider = window.localStorage.getItem("provider");
    if (savedprovider) {
        if (savedprovider == 'injected') {
            metaMask.connectEagerly().catch(() => {
            console.debug('Failed to connect eagerly to metamask')
            })
        } else if (savedprovider == 'walletConnect') {
            walletConnectV2.connectEagerly().catch((error) => {
                console.debug('Failed to connect eagerly to walletconnect', error)
              })
        }/* else {
            if (connector?.deactivate) {
            connector.deactivate()
            } else {
            connector.resetState()
            }
        }*/
    }
    if (provider) {
        loadBlockchainData();
    }
  }, []);

  useEffect(() => {
    const switchEffect = async () => {
        await switchNetwork();
    };

    if (provider) {
        switchEffect();
        loadBlockchainData();
    }
  }, [provider, chainId, account]);

  const loadBlockchainData = async () => {
    try {
        const signer = provider.getSigner();
        const networkId = chainId;

        const tokenData = USDTBEP20.networks[networkId];
        const bayonTokenData = BayonToken.networks[networkId];
        const crowdsaleData = Crowdsale.networks[networkId];

        if (tokenData) {
            let bayonTokenContract = new ethers.Contract(
                bayonTokenData.address, //BayonToken
                BayonToken.abi,
                signer
            );

            let tokenContract = new ethers.Contract(
                tokenData.address, //USDTBEP20
                USDTBEP20.abi,
                signer
            );

            let CrowdsaleContract = new ethers.Contract(
                crowdsaleData.address,
                Crowdsale.abi,
                signer
            );


            dispatch(
                setBayonTokenInfo({ address: bayonTokenData.address, contract: bayonTokenContract })
            );

            dispatch(
                setTokenInfo({ address: tokenData.address, contract: tokenContract })
            );

            let address = crowdsaleData.address;
            let contract = CrowdsaleContract;
            let tokenPrice = await CrowdsaleContract.getTokenPrice();
            let tokenPriceBucks = await CrowdsaleContract._rate();
            let tokenAllFrozen = await CrowdsaleContract.frozenTokens(
                account
            );
            let tokenAllWithdrawn = await CrowdsaleContract.withdrawnTokens(
                account
            );
            let tokensSold = await CrowdsaleContract._tokensSold();
            let tokenMyFrozen =
                (tokenAllFrozen - tokenAllWithdrawn) / 10 ** 18;
            let tokenBnbPrice =
                tokenPriceBucks /
                10 ** 8 /
                ((tokenPrice / 10 ** 8) * (tokenPriceBucks / 10 ** 8));
            let bnbBalance = await provider.getBalance(account);

            //setCrowdsaleAddress(CrowdsaleContract.address);
            //setCrowdsaleContract(contract);

            dispatch(
                setCrowdsaleInfo({
                    address: address,
                    contract: contract,
                    tokenPrice: tokenPrice,
                    tokenPriceBucks: tokenPriceBucks,
                    tokenBnbPrice: tokenBnbPrice,
                    tokensSold: tokensSold,
                    tokenMyFrozen: tokenMyFrozen
                })
            );
        }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  async function addToken() {
    const bayonTokenData = BayonToken.networks[chainId];
    const tokenSymbol = "BAY";
    const tokenDecimals = 18;
    const tokenImage = "";

    try {
        const wasAdded = await provider.request({
            method: "wallet_watchAsset",
            params: {
                type: "ERC20",
                options: {
                    address: bayonTokenData.address,
                    symbol: tokenSymbol,
                    decimals: tokenDecimals,
                    image: tokenImage,
                },
            },
        });

        if (wasAdded) {
            // console.log("Thanks for your interest!");
        } else {
            // console.log("Your loss!");
        }
    } catch (error) {
        // console.log(error);
    }
  }

  const switchNetwork = async () => {
    let provider = window.localStorage.getItem("provider");
    if (provider === "injected") {
        const chainHex = "0x38";
        //const chainHex = '0x61';
        try {
            await provider.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: chainHex }],
            });
        } catch (switchError) {
            console.log(switchError);
            if (switchError.code === 4902 || switchError.code === -32603) {
                try {
                    await provider.request({
                        method: "wallet_addEthereumChain",
                        params: [
                            {
                                chainName: "Binance Smart Chain",
                                chainId: chainHex,
                                nativeCurrency: {
                                    name: "BNB",
                                    decimals: 18,
                                    symbol: "BNB",
                                },
                                rpcUrls: [
                                    "https://bsc-dataseed.binance.org/",
                                ],
                                blockExplorerUrls: ["https://bscscan.com/"],
                                /*rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
                    blockExplorerUrls: ['https://testnet.bscscan.com/']*/
                            },
                        ],
                    });
                } catch (error) {
                    window.alert(error);
                }
            }
        }
    }
  };

  const disconnect = () => {
    if (connector?.deactivate) {
        connector.deactivate()
    } else {
        connector.resetState()
    }
    setLoading(true);
  };

  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter history={history}>
        <Routes>
            <Route
                path="/"
                element={
                    <Landing loading={loading} />
                }
            />
            <Route
                path="/dashboard"
                element={
                    <Dashboard
                        loading={loading}
                        disconnect={disconnect}
                        page="main"
                    />
                }
            />           
            <Route 
                path="/link/:rLink" 
                element={<RLink />}
            />
            <Route 
                path="/clear" 
                element={<ClearCache />}
            />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}